module.exports = __webpack_public_path__ + "media/images/front/brands/creations/card-04af7ec2fa5ec639a161a9d478e2aa48.jpg";